import content from './content';
import { useState } from 'react';
import Button from '@CS/components/Button';
import { useTranslation } from '@CS/hooks';
import { Text, Title } from './PopUpDeleteMember.styles';
import { type PopupProps, Popup, FADE_DURATION } from '@CS/components/Popups';

type PopUpDeleteMemberProps = PopupProps & {
  onDelete: () => void;
};

export const PopUpDeleteMember = ({
  onDelete,
  ...props
}: PopUpDeleteMemberProps) => {
  const onConfirm = () => setTimeout(onDelete, FADE_DURATION) && onCancel();
  const { title, text, cancel, confirm } = useTranslation(content);

  const [closed, setClosed] = useState(false);
  const onCancel = () => setClosed(true);

  return (
    <Popup close={closed} {...props}>
      <Title>{title}</Title>
      <Text>{text}</Text>

      <Button onClick={onCancel} text={cancel} margin="0 0 8px" />
      <Button onClick={onConfirm} text={confirm} variant="secondary" />
    </Popup>
  );
};
